// extracted by mini-css-extract-plugin
module.exports = {"container":"e_4q","link":"e_5q","imageContainer":"e_6q","author":"e_7q","text":"e_8q","buttonIcon":"e_9q"};